module.exports = __webpack_public_path__ + "img/howtop1-100.59cb5c70.jpg";